import { isEmptyField } from '../../generated/ast.js';
import { ANY_NODE_STRING, FRONTEND_PROPERTY_NAME, } from '../../common/constants.js';
export function validateWhatsNext(node, nodeFields, pifFileSummary, accept) {
    const { idField, nodeTypeField, whatsNextField } = nodeFields;
    // whatsNext is only for action nodes
    if (nodeTypeField?.nodeType?.value === 'A')
        return;
    // Check that whatsNext field is not set to empty/null
    if (!whatsNextField || isEmptyField(whatsNextField?.whatsNext)) {
        accept('error', "Missing required 'whatsNext' field for this node.", {
            node,
            data: {
                id: idField?.id?.value,
                nodeNumber: node?.name,
                propertyName: FRONTEND_PROPERTY_NAME.WHATS_NEXT,
            },
        });
    }
    else {
        // If it is not set to the special 'any_node' value, then parse and validate
        // individual items in the string
        const whatsNextString = whatsNextField.whatsNext?.value?.trim() || '';
        if (whatsNextString === ANY_NODE_STRING)
            return;
        const whatsNextItems = whatsNextString.split('|');
        // If we have multiple WhatsNextItems defined, we also want to
        // ensure that the values are not duplicated in the entries as
        // that would mean same value being mapped to multiple nodes
        const valueFlags = {};
        whatsNextItems.forEach((whatsNextItem) => {
            // Each individual item has the format value~destination
            // Get the individual parts of the string
            const indexOfTilde = whatsNextItem.indexOf('~');
            if (indexOfTilde === -1) {
                accept('error', `The whatsNext item is not formatted correctly. It should be in the format 'value ~ destination'.`, {
                    node: whatsNextField,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: nodeFields.nodeNumber,
                        propertyName: FRONTEND_PROPERTY_NAME.WHATS_NEXT,
                    },
                });
            }
            else {
                // Split the string into it's parts.
                const value = whatsNextItem.slice(0, indexOfTilde).trim();
                const nodeNumber = whatsNextItem.slice(indexOfTilde + 1).trim();
                if (valueFlags[value]) {
                    accept('error', `Duplicate value '${value}' found in whats next field.`, {
                        node: whatsNextField,
                        data: {
                            id: idField?.id?.value,
                            nodeNumber: node?.name,
                            propertyName: FRONTEND_PROPERTY_NAME.WHATS_NEXT,
                        },
                    });
                }
                valueFlags[value] = true;
                // The referenced node must exist
                const refNodeFields = pifFileSummary.getNodeByNodeNumber(nodeNumber);
                if (!refNodeFields) {
                    accept('error', `Could not resolve reference to Node named '${nodeNumber}'.`, {
                        node: whatsNextField,
                        data: {
                            id: idField?.id?.value,
                            nodeNumber: nodeFields.nodeNumber,
                            propertyName: FRONTEND_PROPERTY_NAME.WHATS_NEXT,
                        },
                    });
                }
            }
        });
    }
}
//# sourceMappingURL=validate-whats-next.js.map